import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../styles/Admin.css';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('로그아웃 중 오류 발생:', error);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <span>ClassTrans</span>
      </div>

      <nav className="sidebar-nav">
        <Link to="/admin" className={`sidebar-link ${isActive('/admin')}`}>
          <span>사용자 관리</span>
        </Link>
        <Link to="/admin/classes" className={`sidebar-link ${isActive('/admin/classes')}`}>
          <span>수업 관리</span>
        </Link>
        <button onClick={handleLogout} className="sidebar-link logout-button">
          <span>로그아웃</span>
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
